import { connect } from "react-redux";
import IAppState from "../../../../redux/types/IAppState";
import { showModal, showYesNoPrompt, hideModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import { addTab,  setChangesMade, resetMessageBanner, updateEditableFields, setEditableFields, openAccordion, closeAccordion, updateArtistField, createNewArtist, sortArtistFieldData, incrementTempID } from "../../../../redux/reducers/RepertoireReducer";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { ISocIP } from "../../../types/ISocIP";
import {  deleteArtistThunk, saveArtistThunk, undoArtistChangesThunk, updateComponentFieldItemsThunk, updateUserPreferencesThunk } from "../../../../redux/thunks/RepertoireThunks";
import { IYesNoPromptViewModalProps } from "../../../components/modalViews/yesNoPromptView/YesNoPromptView";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IResultsPerPage } from "../../../../redux/types/IResultsPerPage";
import { IActiveAccordion } from "../../../../redux/types/IActiveAccordion";
import { IShowFieldSettingViewModalProps } from "../../../components/repertoireModal/RepertoireModal";
import { IArtistState, IArtistStateKeys } from "../../../../redux/types/IArtistState";
import { ArtistMaintenancePage } from "./ArtistMaintenancePage";
import { IArtistCore } from "../../../types/IArtistCore";
import ArtistMaintenancePageScrollListener from "./ArtistMaintenancePageScrollListener";
import { ITabProps } from "../../../../redux/types/ITabProps";


export default connect(
    (state: IAppState, props: ITabProps) => ({
        artistMaintenanceGeneralDataViewData:
            state.repertoire.componentData.ArtistMaintenanceGeneralDataView,
        artistMaintenanceGridsViewData:
            state.repertoire.componentData.ArtistMaintenanceGridsView,
        artistMaintenanceAccordionViewData:
            state.repertoire.componentData.ArtistMaintenanceAccordionView,
        artistMaintenanceToolbarData:
            state.repertoire.componentData.ArtistMaintenanceToolbar,
        artistMaintenanceSaveResultData:
            state.repertoire.componentData.SaveResult,
        dataGridTableData:
            state.repertoire.componentData.DataGridTable,
        activeTab: state.repertoire.panes[props.paneIndex].activeTab,
        tabs: state.repertoire.panes[props.paneIndex].tabs,
        activeAccordion: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab] && state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].activeAccordions,
        loaded: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].artistMaintenanceState && state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].artistMaintenanceState.loaded,
        artist: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].artistMaintenanceState && state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].artistMaintenanceState.artist,
        editableFieldsDataView: state.repertoire.componentData.EditableFieldsDataView,
        workflowFieldsData: state.repertoire.componentData.WorkflowFieldsData,
        lookupValues: state.lookupEntities,
        defaultActiveAccordions: state.repertoire.defaultActiveAccordions,
        allResultsPerPage: state.repertoire.resultsPerPage,
        editableFields: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].editableFields && state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].editableFields,
        roles: state.account.roles,
    }),
    dispatch => ({
        showModal: (
            modalContent: string,
            modalComponentInstance: string,
            modalProps: any,
            displayModalCloseButton: boolean,
            title: string,
            modalMessage?: string
        ) =>
            dispatch(
                showModal(modalContent, modalComponentInstance, modalProps, displayModalCloseButton, title, modalMessage)
            ),
        hideModal: () => dispatch(hideModal()),
        resetMessageBanner: () => dispatch(resetMessageBanner()),
        addTab: (tab: ITabReduxItem) =>
            dispatch(addTab(tab)),
        setChangesMade: (tabIndex: number, changesMade: boolean) =>
            dispatch(setChangesMade(tabIndex, changesMade)),
        updateArtistField: (value: any, fieldName: IArtistStateKeys) =>
            dispatch(updateArtistField(value, fieldName)),
        saveChanges: (artist: IArtistState, artistMaintenanceGeneralDataViewData: IRepertoireComponentDataItem) =>
            dispatch<any>(saveArtistThunk(artist, artistMaintenanceGeneralDataViewData)),
        addNewArtist: (lookupValues: ILookupDictionary, isNew?: boolean, artistMaintenanceGeneralDataView?: IRepertoireComponentDataItem) =>
            dispatch<any>(createNewArtist(lookupValues, isNew, artistMaintenanceGeneralDataView)),
        sortArtistFieldData: (value: any, fieldName: IArtistStateKeys) =>
            dispatch(sortArtistFieldData(value, fieldName)),
        openArtistAccordion: (accordionName: string, componentName: string) =>
            dispatch(openAccordion(accordionName, componentName)),
        closeArtistAccordion: (accordionName: string, componentName: string) =>
            dispatch(closeAccordion(accordionName, componentName)),
        undoArtistChanges: (performerID: number) =>
            dispatch<any>(undoArtistChangesThunk(performerID)),
        deleteArtist: (performerID: number, activeTab?: number) =>
            dispatch<any>(deleteArtistThunk(performerID, activeTab)),
        showYesNoPrompt: (title: string, props: IYesNoPromptViewModalProps, message?: string, detailMessage?: string) =>
            dispatch(showYesNoPrompt(title, props, message, detailMessage)),
        setEditableFields: (componentFieldName: string, componentInstance: string) =>
            dispatch<any>(setEditableFields(componentFieldName, componentInstance)),
        updateEditableField: (value: any, key: string) =>
            dispatch(updateEditableFields(value, key)),
        showUpdateFieldsModal: (tittle: string, props: IShowFieldSettingViewModalProps) =>
            dispatch<any>(showUpdateFieldsModal(tittle, props)),
        updateComponentFieldsItems: (
            fields: IRepertoireField[],
            componentName: string,
            componentInstance: string,
            componentDataFieldName: string,
            tabs: ITabReduxItem[],
            activeTab: number) => dispatch<any>(updateComponentFieldItemsThunk(fields, componentName, componentInstance, componentDataFieldName, tabs, activeTab)),
        updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => dispatch<any>(updateUserPreferencesThunk(allResultsPerPage, activeAccordions, newActiveAccordionName, accordionExpanded, componentName, indexOfFirstResult, indexOfLastResult, resultsPerPage, repertoireSection)),
        incrementTempID: () => dispatch<any>(incrementTempID())

    })
)(ArtistMaintenancePageScrollListener);